import { AxiosMode } from './Model.class';

export interface ThirdAccountInfo {
  unionid?: string;
  openid?: string;
  qq_openid?: string;
  wx_openid?: string;
  sp_openid?: string;
  mp_openid?: string;
  qq_name?: string;
  wx_name?: string;
  mp_name?: string;
}

export class UserApis extends AxiosMode {
  getUser() {
    return super.post({
      remotePath: AxiosMode.API_HOST + '/api/user/get-user'
    });
  }

  signOut() {
    return super.post({
      remotePath: AxiosMode.API_HOST + '/api/user/sign-out'
    });
  }

  getThirdInfo() {
    return super.post({
      remotePath: AxiosMode.API_HOST + '/api/third/get-third-info'
    });
  }

  getCode(params: { account: string; operateId: number; areaCode?: number; checkCode?: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/common/get-code'
    });
  }

  getUnbindPhoneCode() {
    return super.post({
      remotePath: AxiosMode.API_HOST + '/api/user/get-unbind-code'
    });
  }

  checkUnbindPhoneCode(params: { verifyCode: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/check-unbind-code'
    });
  }

  changeBindPhone(params: {
    account: string;
    areaCode?: number;
    verifyCode: string;
    password?: string;
    checkCode?: string;
  }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/bind-account'
    });
  }

  retrievePassword(params: { account: string; password: string; verifyCode: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/retrieve-password'
    });
  }

  updatePassword(params: { oldPass: string; newPass: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/update-password'
    });
  }

  loginProgress(params: { 'X-Fsh5-Sessionid': string; getCode: number }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/third/get-progress'
    });
  }

  operateThirdAccount(params: { operate: number; type: number }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/third/bind-unbind-third'
    });
  }

  updateUserLogo(params: { fileName: string; operateId: number }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/update-user-logo'
    });
  }

  updateUserInfo(params: {
    uName: string;
    phone?: string;
    company?: string;
    about?: string;
    website?: string;
    address?: string;
  }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/update-user-settings'
    });
  }

  checkAccountExist(params: { account: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/check-email'
    });
  }

  getCustomPower() {
    return super.post({
      remotePath: AxiosMode.API_HOST + '/api/power/get-user-custom-config'
    });
  }

  cancelAccount(params: { verifyCode: string }) {
    return super.post({
      postData: params,
      remotePath: AxiosMode.API_HOST + '/api/user/cancel-account'
    });
  }
}

/** User API 单例，全局复用同一实例 */
export const userApis = new UserApis();
